import React from 'react';
import TopNavbar from '../../components/Nav/TopNavbar';
import Footer from '../../components/Sections/Footer/Footer';
import frame from "../../assets/blog/frame.png";
import bg1 from "../../assets/blog/bg1.png";
import style from "./Blog.module.css";
import blogTest from "../../assets/blog/blogTest.png";

// PostCard component
const PostCard = ({ image, category, title, authorImage, authorName, date }) => {
    return (
        <div className="col-12 col-md-4 pl-sm-4 pr-0 mb-4 p-0 d-flex justify-content-center ">
            <div style={{

                backgroundColor: 'white',
                borderRadius: '10px',
                // border: '1px solid #6c63ff', // Border applied for a consistent look
                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                overflow: 'hidden',
                transition: 'transform 0.3s ease-in-out',
                padding: '15px', // Increased padding within the card
                width: '330px',

                // maxWidth: 350px',
                // margin: '0 auto',
            }}
            >
                <img alt={title} src={image} className="card-fluids m-0 " />
                <div style={{ padding: '6px' }}>
                    <div className="p-1"
                        style={{
                            backgroundColor: "rgba(75, 107, 251, 0.05)",
                            width: "65px",
                            borderRadius: "5px"
                        }}
                    >
                        <div
                            style={{
                                // color: '#6c63ff',
                                fontWeight: '500',
                                fontSize: '10px',
                            }}
                        >
                            {category}
                        </div>
                    </div>
                    <div
                        className='mt-1 mb-2'
                        style={{
                            fontFamily: "Barlow,sans-serif",
                            color: '#160A54',
                            fontWeight: '600',
                            fontSize: '18px',

                        }}
                    >
                        {title}
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            fontSize: '14px',
                            color: '#6c757d',

                        }}
                    >
                        <img
                            alt={authorName}
                            src={authorImage}
                            height="30"
                            width="30"
                            style={{
                                borderRadius: '50%',
                                marginRight: '10px',
                            }}
                        />
                        <span>{authorName}</span>
                        <span style={{ marginLeft: '10px' }}>{date}</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default function Blog() {
    const { bg_purple } = style;

    // Array of posts
    const posts = [
        {
            image: 'https://storage.googleapis.com/a1aa/image/CsTBghS5KHo1CV5gik4RTUohLP0dYRVouiZ8yw2YbC6usu7E.jpg',
            category: 'Technology',
            title: 'The Impact of Technology on the Workplace: How Technology is Changing',
            authorImage: 'https://storage.googleapis.com/a1aa/image/tMGNsl9hJ9YQKhziA224mrXTTmZyRGSt8qtiSFBLJp7vsu7E.jpg',
            authorName: 'Tracey Wilson',
            date: 'August 20, 2022',
        },
        // Other posts...
        {
            image: 'https://storage.googleapis.com/a1aa/image/CsTBghS5KHo1CV5gik4RTUohLP0dYRVouiZ8yw2YbC6usu7E.jpg',
            category: 'Technology',
            title: 'The Impact of Technology on the Workplace: How Technology is Changing',
            authorImage: 'https://storage.googleapis.com/a1aa/image/tMGNsl9hJ9YQKhziA224mrXTTmZyRGSt8qtiSFBLJp7vsu7E.jpg',
            authorName: 'Tracey Wilson',
            date: 'August 20, 2022',
        },
        {
            image: 'https://storage.googleapis.com/a1aa/image/CsTBghS5KHo1CV5gik4RTUohLP0dYRVouiZ8yw2YbC6usu7E.jpg',
            category: 'Technology',
            title: 'The Impact of Technology on the Workplace: How Technology is Changing',
            authorImage: 'https://storage.googleapis.com/a1aa/image/tMGNsl9hJ9YQKhziA224mrXTTmZyRGSt8qtiSFBLJp7vsu7E.jpg',
            authorName: 'Tracey Wilson',
            date: 'August 20, 2022',
        },
        {
            image: 'https://storage.googleapis.com/a1aa/image/CsTBghS5KHo1CV5gik4RTUohLP0dYRVouiZ8yw2YbC6usu7E.jpg',
            category: 'Technology',
            title: 'The Impact of Technology on the Workplace: How Technology is Changing',
            authorImage: 'https://storage.googleapis.com/a1aa/image/tMGNsl9hJ9YQKhziA224mrXTTmZyRGSt8qtiSFBLJp7vsu7E.jpg',
            authorName: 'Tracey Wilson',
            date: 'August 20, 2022',
        },
        {
            image: 'https://storage.googleapis.com/a1aa/image/CsTBghS5KHo1CV5gik4RTUohLP0dYRVouiZ8yw2YbC6usu7E.jpg',
            category: 'Technology',
            title: 'The Impact of Technology on the Workplace: How Technology is Changing',
            authorImage: 'https://storage.googleapis.com/a1aa/image/tMGNsl9hJ9YQKhziA224mrXTTmZyRGSt8qtiSFBLJp7vsu7E.jpg',
            authorName: 'Tracey Wilson',
            date: 'August 20, 2022',
        },
        {
            image: 'https://storage.googleapis.com/a1aa/image/CsTBghS5KHo1CV5gik4RTUohLP0dYRVouiZ8yw2YbC6usu7E.jpg',
            category: 'Technology',
            title: 'The Impact of Technology on the Workplace: How Technology is Changing',
            authorImage: 'https://storage.googleapis.com/a1aa/image/tMGNsl9hJ9YQKhziA224mrXTTmZyRGSt8qtiSFBLJp7vsu7E.jpg',
            authorName: 'Tracey Wilson',
            date: 'August 20, 2022',
        },
        {
            image: 'https://storage.googleapis.com/a1aa/image/CsTBghS5KHo1CV5gik4RTUohLP0dYRVouiZ8yw2YbC6usu7E.jpg',
            category: 'Technology',
            title: 'The Impact of Technology on the Workplace: How Technology is Changing',
            authorImage: 'https://storage.googleapis.com/a1aa/image/tMGNsl9hJ9YQKhziA224mrXTTmZyRGSt8qtiSFBLJp7vsu7E.jpg',
            authorName: 'Tracey Wilson',
            date: 'August 20, 2022',
        },
        {
            image: 'https://storage.googleapis.com/a1aa/image/CsTBghS5KHo1CV5gik4RTUohLP0dYRVouiZ8yw2YbC6usu7E.jpg',
            category: 'Technology',
            title: 'The Impact of Technology on the Workplace: How Technology is Changing',
            authorImage: 'https://storage.googleapis.com/a1aa/image/tMGNsl9hJ9YQKhziA224mrXTTmZyRGSt8qtiSFBLJp7vsu7E.jpg',
            authorName: 'Tracey Wilson',
            date: 'August 20, 2022',
        },
        {
            image: 'https://storage.googleapis.com/a1aa/image/CsTBghS5KHo1CV5gik4RTUohLP0dYRVouiZ8yw2YbC6usu7E.jpg',
            category: 'Technology',
            title: 'The Impact of Technology on the Workplace: How Technology is Changing',
            authorImage: 'https://storage.googleapis.com/a1aa/image/tMGNsl9hJ9YQKhziA224mrXTTmZyRGSt8qtiSFBLJp7vsu7E.jpg',
            authorName: 'Tracey Wilson',
            date: 'August 20, 2022',
        },
    ];

    return (
        <>
            {/* Main Container */}
            <div
                className={`container-fluid m-0 p-0 ${bg_purple}`}
                style={{
                    backgroundImage: `url(${frame})`,
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    borderRadius: '20px',
                }}
            >
                <TopNavbar />
            </div>

            {/* Content Area */}
            <div className={`container-fluid m-0 pl-sm-5 pr-sm-5 ${bg_purple}`}>
                {/* Main Image Section */}
                <div className='d-flex justify-content-start'>
                    <div className="row pb-sm-5">
                        <div className="position-relative">
                            <div>
                                <img
                                    src={blogTest}
                                    className="m-0 wounded  position-relative pl-sm-5 pr-sm-5"
                                    alt="Secondary background image"
                                    style={{
                                        zIndex: 1,
                                        width: '100%',
                                    }}
                                />
                            </div>
                            {/* Overlay with Content */}
                            <div
                                className="position-absolute bg-white p-3 shadow-sm"
                                style={{
                                    bottom: '-45px',
                                    left: '142px',
                                    zIndex: 3,
                                    width: '420px',
                                    borderRadius: '10px',
                                }}
                            >
                                <div className='pl-2'>
                                    <div
                                        className="tag badge mb-2 "
                                        style={{
                                            backgroundColor: "#160A54",
                                            color: "white",
                                            fontSize: "10px",
                                            padding: "5px 8px",
                                            fontWeight: "500"
                                        }}
                                    >
                                        <div>Technology</div>
                                    </div>
                                </div>


                                <h2 className="title h4 mb-2 pl-2"
                                    style={{ color: "#160A54", fontWeight: "600" }}>
                                    The Impact of Technology on the Workplace: How Technology is Changing
                                </h2>
                                <div className="author pl-2 pb-3 d-flex align-items-center text-muted">
                                    <img
                                        src="https://storage.googleapis.com/a1aa/image/xryAnF7624YfHSMAVVjcEe3bulSrKt2ahTvDhgJ1fAJKzQZnA.jpg"
                                        className="rounded-circle mr-2"
                                        alt="Author's profile picture"
                                        width="25"
                                        height="25"
                                    />
                                    <span style={{
                                        fontSize: "11px",
                                        fontWeight: "500",
                                        color: "97989F",
                                        fontFamily: "Barlow,sans-serif",
                                    }}>Jason Francisco</span>
                                    <span style={{
                                        fontSize: "11px",
                                        fontWeight: "500",
                                        color: "97989F",
                                        fontFamily: "Barlow,sans-serif",
                                    }} className="ml-2">August 20, 2022</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Latest Posts Section */}
                <div className="container-fluid  mt-3"
                    style={{
                        fontFamily: 'Barlow, sans-serif',
                        fontSize: 'larger',
                    }}
                >
                    <div className='d-flex' style={{ marginLeft: "105px" }} >
                        <div className="mt-5 pt-5">
                            <h3 style={{ fontSize: "19px", fontFamily: "Barlow,sans-serif", fontWeight: "bold", color: '#160A54' }} >Latest Post</h3>
                        </div>
                    </div>
                </div>

                {/* Blog Cards Container */}
                <div className="container-fluid mt-4 p-0 " style={{
                    // marginright: '10px',
                    // marginleft: '10px',
                    // paddingright: '110px',
                    // paddingleft: '110px',
                }}>
                    <div className="row">
                        {posts.map((post, index) => (
                            <PostCard key={index} {...post} />
                        ))}
                    </div>
                </div>

                {/* View More Button */}
                <div className="text-center pb-5">
                    <button
                        className="btn btn-primary"
                        style={{
                            padding: '8px 15px',
                            fontSize: '11.5px',
                            fontWeight: "500",
                            fontFamily: "Barlow,sans-serif",
                            borderRadius: '6px',
                            backgroundColor: 'transparent',
                            color: "#160A54",
                            border: "1px solid #160A54",

                        }}
                        onMouseOver={(e) => (e.target.style.backgroundColor = '#5b53e1')}
                        onMouseOut={(e) => (e.target.style.backgroundColor = '#6c63ff')}
                    >
                        View All Post
                    </button>
                </div>
            </div>

            <Footer />
        </>
    );
}
